import {REHYDRATE} from 'redux-persist/constants'
import actiontypes from '../actiontypes'


const initialState = {
    initializing: true,
    nav_is_open: false,
}

const guiReducer = (state=initialState, action) => {
    switch (action.type) {
        case REHYDRATE: {
            const incoming = action.payload.gui
            if (incoming) {
                return {
                    ...state, 
                    initializing: false
                }
            }
            return state
        }
        case actiontypes.CLOSE_NAV:
            return {
                ...state,
                nav_is_open: false
            }
        case actiontypes.TOGGLE_NAV:
            return {
                ...state,
                nav_is_open: !state.nav_is_open
            }
        default:
            return state;
    }
}

export default guiReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/gui.js
 **/